import {
    CommonSharedByType,
    mapCommonSharedByType,
} from "../../Share/CommonSharedByType";
import { mapShareContactTypes, ShareContactTypes } from "../ShareContactTypes";
import { mapMaterialTypes, MaterialType } from "./MaterialType";

export interface MaterialPojectType {
    project_id?: number;
    job_number?: string;
    project_type?: "CP" | "DP";
    description?: string;
    status?: "Current" | "Ongoing" | "Completed";
    user_id?: number;
    address?: string;
    post_code?: string;
    is_material_project_list?: boolean;
    have_material?: boolean;
    total_spend_all: number | null;
    material_data?: MaterialType[];
    is_own_project?: boolean;
    contact?: ShareContactTypes[];
    share_list?: ShareContactTypes[];
    shared_by: CommonSharedByType | null;
    can_edit?: boolean;
}

// to single object maping
export const mapMaterialProjectType = (data: any): MaterialPojectType => {
    if (!data) {
        throw new Error("Invalid Data");
    }
    const input: MaterialPojectType = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description,
        status: data.status,
        user_id: data.user_id,
        address: data.address,
        post_code: data.post_code,
        is_material_project_list: data.is_material_project_list,
        have_material: data.have_material,
        total_spend_all: data.total_spend_all || 0,
        material_data: mapMaterialTypes(data.material_data),
        is_own_project: data.is_own_project,
        contact: mapShareContactTypes(data.contact),
        share_list: mapShareContactTypes(data.share_list),
        shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
        can_edit: data.can_edit,
    };
    return input;
};

// maping list objects
export const mapMaterialProjectTypes = (data: any[]): MaterialPojectType[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }
    return data.map(mapMaterialProjectType);
};
